import { loadStoreSettings } from "./storeSettings";

let activePixelId = "";

export function normalizeMetaPixelId(value) {
  const id = String(value || "").trim();
  return /^\d{5,20}$/.test(id) ? id : "";
}

function installMetaPixelQueue() {
  if (typeof window === "undefined" || typeof document === "undefined") return null;
  if (window.fbq) return window.fbq;

  const fbq = function () {
    if (fbq.callMethod) fbq.callMethod.apply(fbq, arguments);
    else fbq.queue.push(arguments);
  };
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = "2.0";
  fbq.queue = [];
  window.fbq = fbq;
  window._fbq = fbq;

  if (!document.querySelector('script[data-meta-pixel="true"]')) {
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://connect.facebook.net/en_US/fbevents.js";
    script.dataset.metaPixel = "true";
    document.head.appendChild(script);
  }
  return fbq;
}

export function initializeMetaPixel(settings) {
  if (typeof window === "undefined" || window.parent !== window) return false;
  const enabled = settings?.metaPixelEnabled === true || settings?.metaPixelEnabled === "true";
  const pixelId = normalizeMetaPixelId(settings?.metaPixelId);
  if (!enabled || !pixelId) return false;

  const fbq = installMetaPixelQueue();
  if (!fbq) return false;
  if (activePixelId !== pixelId) {
    fbq("init", pixelId);
    activePixelId = pixelId;
  }
  return true;
}

export function trackMetaPixel(eventName, parameters = {}, options = {}) {
  if (!activePixelId || typeof window === "undefined" || typeof window.fbq !== "function") return false;
  const command = options.custom ? "trackCustom" : "track";
  if (options.eventId) {
    window.fbq(command, eventName, parameters, { eventID: String(options.eventId) });
  } else {
    window.fbq(command, eventName, parameters);
  }
  return true;
}

export async function configureMetaPixel() {
  const settings = await loadStoreSettings();
  return initializeMetaPixel(settings);
}

export async function trackConfiguredMetaPixel(eventName, parameters = {}, options = {}) {
  const configured = await configureMetaPixel();
  return configured ? trackMetaPixel(eventName, parameters, options) : false;
}

export function trackMetaPurchaseOnce(orderId, parameters) {
  const key = `meta_pixel_purchase_${String(orderId || "unknown")}`;
  try {
    if (sessionStorage.getItem(key)) return false;
    const tracked = trackMetaPixel("Purchase", parameters, { eventId: `purchase_${String(orderId)}` });
    if (tracked) sessionStorage.setItem(key, "1");
    return tracked;
  } catch (error) {
    return trackMetaPixel("Purchase", parameters);
  }
}
